import React from 'react';
import { shape, string, bool } from 'prop-types';
import { getAlertMessaging } from '../../../utils/product-unavailable-utils';
import { BundleAlertmessage } from '../BundleAlertmessage';

export const BundleUnavailableAlert = ({
  product,
  bundleProduct
}) => {
  const { unavailableAlertMessage } = bundleProduct?.features ?? {};

  const alertMessage = getAlertMessaging({ product, bundleProduct });

  if (!unavailableAlertMessage || !alertMessage) {
    return null;
  }

  return (
    <div className="sui-mb-2">
      <BundleAlertmessage status="error" alertSize="small" alertBodyText={alertMessage} />
    </div>
  );
};

BundleUnavailableAlert.propTypes = {
  product: shape({
    isOOS: bool
  }).isRequired,
  bundleProduct: shape({
    features: shape({
      unavailableAlertMessageText: string
    })
  }).isRequired
};